<div class="card-view-controls">
  <!-- Sort Control -->
  @if (showSort() && viewState().sortById) {
    <zag-card-view-action-button
      class="control-button"
      label="cardView.controls.sort"
      [currentValue]="viewState().sortById!"
      [options]="sortOptions()"
      dropdownTitle="cardView.controls.sortBy"
      (optionSelected)="onSortChange($event)"
    >
    </zag-card-view-action-button>
  }

  <!-- Page Size Control -->
  @if (showPageSize() && viewState().pageSize !== undefined) {
    <zag-card-view-action-button
      class="control-button"
      label="cardView.controls.pageSize"
      [currentValue]="viewState().pageSize!.toString()"
      [options]="pageSizeOptions()"
      dropdownTitle="cardView.controls.itemsPerPage"
      (optionSelected)="onPageSizeChange($event)"
    >
    </zag-card-view-action-button>
  }

  <!-- View Mode Control -->
  @if (showViewMode()) {
    <zag-card-view-action-button
      class="control-button"
      label="cardView.controls.viewMode"
      [currentValue]="viewState().viewModeId"
      [options]="viewModeOptions()"
      dropdownTitle="cardView.controls.selectViewMode"
      (optionSelected)="onViewModeChange($event)"
    >
    </zag-card-view-action-button>
  }
</div>
